"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_1 = require("@tencent/spaui");
var AddComponent = function AddComponent(props) {
  var hottag = props.hottag,
    onAdd = props.onAdd,
    addButton = props.addButton,
    addButtonClassName = props.addButtonClassName,
    addButtonProps = props.addButtonProps,
    addButtonPrefix = props.addButtonPrefix,
    addButtonSuffix = props.addButtonSuffix,
    showLength = props.showLength,
    maxLength = props.maxLength,
    data = props.data;
  return addButton && data.length < maxLength ? react_1["default"].createElement(spaui_1.Button, __assign({
    className: (0, classnames_1["default"])('odc-twins-morebtn', addButtonClassName),
    "data-hottag": "".concat(hottag, ".add"),
    onClick: onAdd,
    icon: react_1["default"].createElement(spaui_1.Icon, {
      name: 'plus-bold-outlined'
    })
  }, addButtonProps), react_1["default"].createElement("span", {
    className: "button-text"
  }, addButtonPrefix, ' ', showLength ? maxLength - data.length : null, ' ', addButtonSuffix)) : null;
};
exports["default"] = AddComponent;